export enum TimeSlotStatus {
    suspended = "suspended",
    scheduled = "scheduled",
    unavailable = "unavailable",
}

export default { TimeSlotStatus };
